const stringHelper = {
    install(app) {
        app.config.globalProperties.$capitalize = (s) => s && s.length > 0 && s[0].toUpperCase() + s.slice(1)
        app.config.globalProperties.$reverse = (s) => s && s.split``.reverse().join``    
    }
}

export default stringHelper;